// extracted by mini-css-extract-plugin
export default {"wrapper":"MvhZKHXHsSudLDweBAyP","btn":"Z5J50uviLsOcsZE93EwX","main":"X4HX9kAtogIDRj79827U","disabled":"Uo_npRemK495uliPfzVm","arrow":"DEq5fkbNKiw3bHwKJFug"};